












import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  Clarity,
  Pace,
  Filler,
  Conciseness,
  Energy,
  Expression,
  Confidence
} from "@/components/Icons";

@Component({
  components: {
    Expression,
    Clarity,
    Pace,
    Filler,
    Conciseness,
    Energy,
    Confidence
  }
})
export default class MetricIcon extends Vue {
  @Prop() private icon?: string;
  private created() {
    // if (this.icon) {
    //   this.icon = this.icon.toLowerCase();
    // }
  }
}
